module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-BlackItalic.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-BlackItalic.eot
 ** module id = 341
 ** module chunks = 0
 **/